<template>
    <div class="d-flex flex-wrap align-items-center py-2 discountRow no-gutters">
        <div class="mr-2">
            {{ name }}
        </div>
        <div class="ml-auto">
            <div class="d-flex justify-content-end">
                <div class="title text-nowrap text-transform-initial">
                    {{ $nf(discountPriceWithVat, 'currency' + currencyCode, 'cs-CZ')}}
                </div>
                <div class="remove-cross-wrap d-none d-md-block"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            discount: {}
        },
        computed: {
            name: function () {
                return this.$t('components.BasketDiscountRow.specialDiscount') + ' ' + this.discount.discount.percentage + ' %' ;
            },
            discountPriceWithVat: function () {
                return -this.discount.discounted.priceWithVat;
            },
            currency: function () {
                return this.discount.discounted.currency.htmlString;
            },
            currencyCode: function () {
                return this.discount.discounted.currency.code;
            }
        }
    };
</script>
